import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { getDocumentName } from '@e-socna/data-layer';
import type { Id } from '@e-socna/data-layer';

import { AuthenticationContextProvider_AuthenticatedUser_QueryDocument } from '../../../../contexts/AuthenticationContext';

import { MyAccountPage_OneUser_QueryDocument } from '../../../MyAccount/queries/one-user.query';
import { UsersPage_ExternalUsersTabPanel_AllExternalUsers_QueryDocument } from '../../../Users/External';
import { UsersPage_InternalUsersTabPanel_AllInternalUsers_QueryDocument } from '../../../Users/Internal';
import { UsersPage_ListForAStatus_SomeUsers_QueryDocument } from '../../../Users/ListForAStatus';

import { UserPage_OneUser_QueryDocument } from '../..';

// The roles and the status of a user show on their page, in the users lists,
// and in the session of the user manager when they change their own user.
export const useInvalidateUserQueries = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (userId: Id) => {
      const documents = [
        MyAccountPage_OneUser_QueryDocument,
        AuthenticationContextProvider_AuthenticatedUser_QueryDocument,
        UsersPage_InternalUsersTabPanel_AllInternalUsers_QueryDocument,
        UsersPage_ExternalUsersTabPanel_AllExternalUsers_QueryDocument,
        UsersPage_ListForAStatus_SomeUsers_QueryDocument,
      ];

      void queryClient.invalidateQueries({
        queryKey: [
          getDocumentName(UserPage_OneUser_QueryDocument),
          { id: userId },
        ],
      });

      for (const document of documents) {
        void queryClient.invalidateQueries({
          queryKey: [getDocumentName(document)],
        });
      }
    },
    [queryClient],
  );
};
